import type { User } from '@mfox/shared/contexts/UserContext'

export const ROLE_LABELS: Record<User['role'], string> = {
  student: 'Student',
  mentor: 'Mentor',
  'college-admin': 'College admin',
  mfox: 'MentorFox admin',
}

/** "karthik.raj@…" reads as "KR"; a single-word name gives its first letter. */
export function initials(email: string): string {
  const parts = email.split('@')[0].split(/[._-]+/).filter(Boolean)
  return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase() || '?'
}

/** The account's name, its email when it has none, and a second line: a student's goal or the role. */
export function accountLines(user: User): { name: string; detail: string } {
  return { name: user.name || user.email, detail: (user.role === 'student' && user.aspiration) || ROLE_LABELS[user.role] }
}
